import { APP_LOADED_SUCCESS, APP_RESET, APP_SETUP, CLEAR_ERRORS, ERROR } from './constants';
import { fromJS } from 'immutable';

export const error = (error) => ({
  type: ERROR,
  payload: fromJS({ error }),
});

export const clearErrors = () => ({
  type: CLEAR_ERRORS,
});

export const appSetup = () => ({
  type: APP_SETUP,
});

export const appLoadedSuccess = () => ({
  type: APP_LOADED_SUCCESS,
});

/** Reset everything except for login */
export const appReset = () => ({
  type: APP_RESET,
});
